import React, { useEffect } from 'react';
import {
    ApplicantDetailsTabs,
    WarningModal,
    ExamApplicationTabs,
    AppType,
} from 'components';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { useLocalErrorHandler } from 'hooks';
import { ApplicantExam } from '../../api/ApiClient';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

const ApplicantDetailsContainer = ({
                                       getApplicantQualificationDetails,
                                       applicantQualificationDetails,
                                       clearApplicantQualificationDetails,
                                       fetchExamApplicationDetails,
                                       getApplicantQualifications,
                                       getApplicantArchiveExams,
                                       getApplicantDetails,
                                       setErrorHandler,
                                       examApplicationDetails,
                                       applicantQualifications,
                                       applicantExams,
                                       applicantDetail,
                                       applicantId,
                                       apiError,
                                       onPush,
                                       tab,
                                   }: Props) => {
    useLocalErrorHandler(setErrorHandler);

    const [selectedExam, setSelectedExam] = React.useState<ApplicantExam | null>(null);
    const [showApplicantDetails, setShowApplicantDetails] = React.useState(false);
    const [processing, setProcessing] = React.useState(false);
    const params = new URLSearchParams(window.location.search);
    const from = params.get('from');

    useEffect(() => {
        clearApplicantQualificationDetails();
        const fetch = async () => {
            setProcessing(true);
            await getApplicantDetails({ applicantId });
            await getApplicantArchiveExams({ applicantId });
            await getApplicantQualifications({ applicantId });
            setProcessing(false);
        };

        fetch();
    }, [applicantId]);

    useEffect(() => {
        if (selectedExam) {
            const fetch = async () => {
                if (selectedExam.examApplicationId) {
                    const res = await fetchExamApplicationDetails(selectedExam.examApplicationId);

                    if (res) {
                        setShowApplicantDetails(true);
                    }
                }
            };

            fetch();
        }
    }, [selectedExam]);

    const handleChooseExam = (examApplicationId: string) => {
        if (!applicantExams || !applicantExams.items) return;
        const exam = applicantExams.items.find(x => x.examApplicationId === examApplicationId);

        if (exam) {
            setSelectedExam(exam);
            setShowApplicantDetails(true);
        }
    };

    const handleCancelClick = () => {
        if (from) {
            onPush(`/${from}`);
        } else {
            onPush('/applicants');
        }
    };

    const onModeExamInfoButtonClick = () => {
        if (examApplicationDetails) {
            onPush(`/exam/${examApplicationDetails.exam.id}`);
        }
    };

    const renderExamMoreInfoButton = () => (
      <Button
        className="mt-5"
        variant="outline-secondary"
        onClick={onModeExamInfoButtonClick}
      >
          Подробная информация об аккредитации
      </Button>
    );

    return (
      <>
          <ApplicantDetailsTabs
            applicantDetail={applicantDetail}
            applicantQualifications={applicantQualifications}
            applicantExams={applicantExams}
            applicantQualificationDetails={applicantQualificationDetails}
            getApplicantQualificationDetails={examApplicationId => getApplicantQualificationDetails({
                applicantId,
                examApplicationId,
            })}
            getApplicantExams={data => getApplicantArchiveExams({ ...data, applicantId })}
            onCancelClick={handleCancelClick}
            onChooseExam={handleChooseExam}
            showLoader={processing}
            apiError={apiError}
            tab={tab}
          />
          {selectedExam && examApplicationDetails ? (
            <WarningModal
              show={showApplicantDetails}
              title={selectedExam.qualificationTitle}
              bodyClassNames="p-0"
              onHide={() => {
                  setSelectedExam(null);
                  setShowApplicantDetails(false);
              }}
              withoutTitleMargin
              withoutCancelButton
              large
            >
                <div className="p-3">
                    <ExamApplicationTabs
                      examApplicationDetails={examApplicationDetails}
                      appType={AppType.Expert}
                      examTabChild={renderExamMoreInfoButton}
                      //   tab={tab}
                      withoutTabPadding
                      inModal
                    />
                </div>
            </WarningModal>
          ) : null}
      </>
    );
};

const mapState = (state: IRootState) => ({
    examApplicationDetails: state.examApplications.examApplicationDetails,
    applicantDetail: state.applicants.applicantDetail,
    applicantQualifications: state.applicants.applicantQualifications,
    applicantExams: state.applicants.applicantArchiveExams,
    applicantQualificationDetails: state.applicants.applicantQualificationDetails,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    getApplicantDetails: dispatch.applicants.getApplicantAsync,
    getApplicantQualifications: dispatch.applicants.getApplicantQualificationsAsync,
    clearApplicantQualificationDetails: dispatch.applicants.clearApplicantQualificationDetails,
    fetchExamApplicationDetails: dispatch.examApplications.fetchExamApplicationDetails,
    getApplicantQualificationDetails: dispatch.applicants.getApplicantQualificationDetailsAsync,
    getApplicantArchiveExams: dispatch.applicants.getApplicantArchiveExamsAsync,
    setErrorHandler: dispatch.errors.setErrorHandler,
});

export default connect(mapState, mapDispatch)(ApplicantDetailsContainer);

interface SelfProps {
    applicantId: string;
    tab: string;
}

type Props = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch> & SelfProps;
